export const CREATE_VEEVA_DATA = `mutation($veevaId: [String]!,$title: [String]!,$country: [String]!){
	veevaDataInsert(input:
		{
			veevaId:$veevaId,
			title:$title,
			country:$country
		}
	)
	{
		veevaData{
			veevaId
			title
			country
		}
	}
}`;

export const GET_ALL_VEEVA_DATA = `query($first:Int,$last:Int,$after:Cursor,$before:Cursor,$filter: VeevaDatumFilter){
    allVeevaData(orderBy:MODIFIED_AT_DESC,first:$first,last:$last,after:$after,before:$before,filter:$filter){
      nodes{
        id
        veevaId
        title
        country  
      }
      totalCount
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }`;

export const UPDATE_VEEVA_DATA = `mutation($id:UUID!,$veevaDatumPatch: VeevaDatumPatch!){
    updateVeevaDatumById(input:{
      id:$id,
      veevaDatumPatch:$veevaDatumPatch
    })
    {
      veevaDatum{
        id
        veevaId
        title
        country
      }
    }
  }`;

export const DELETE_VEEVA_DATA = `mutation($id: UUID!){
    deleteVeevaDatumById(input:{
      id:$id
    })
    {
      veevaDatum{
        id 
      }
    }
  }`;
